import { Directive, HostBinding, Input, OnChanges } from '@angular/core';

@Directive({
    selector: '[csOverrideId]',
    standalone: true
})
export class CsOverrideIdDirective implements OnChanges {
    @Input()
    elementIdPath?: string;

    @Input()
    elementId?: string;

    @Input()
    elementIdImage?: string;

    @HostBinding('attr.data-cs-override-id')
    overrideId?: string;

    last(link: string) {
        const lastWord = link.split('/');
        return lastWord[lastWord.length - 1];
    }

    ngOnChanges() {
        this.overrideId = [this.elementIdPath, this.elementIdImage ? this.last(this.elementIdImage) : this.elementId ? this.elementId : '']
            .filter(i => !!i)
            .join('_')
            .toLowerCase()
            .replace(/\s/g, '-');
    }
}
